import { useCallback, useState } from 'react';

import api from '../../../utils/api';
import snackbar from '../../../utils/snackbar';
import UserSelectDialog from '../../UserSelectDialog/UserSelectDialog';

const useUserSelectDialogForCertifier = (mainUserId: number, saveIfNeeded: () => Promise<void>, excludedIds?: number[], updateData?: () => void, isNewCompany?: boolean, askForAuditor?: () => void) => {
    const [isUserSelectDialogOpen, setIsUserSelectDialogOpen] = useState(false);

    const openUserSelectDialog = useCallback(() => {
        setIsUserSelectDialogOpen(true);
    }, [setIsUserSelectDialogOpen]);

    const closeUserSelectDialog = useCallback((userId?: number) => {
        if (userId) {
            saveIfNeeded().then(() => {
                api.request('/users/' + mainUserId + '/users', 'POST', { userId }).then(() => {
                    snackbar.success('Utente associato con successo!');
                    if (isNewCompany && askForAuditor) {
                        askForAuditor();
                    }
                    if (updateData) {
                        updateData();
                    }
                });
            });
        }
        setIsUserSelectDialogOpen(false);
    }, [saveIfNeeded, askForAuditor, mainUserId, isNewCompany, updateData]);

    const dialog = (
        <>
            <UserSelectDialog open={isUserSelectDialogOpen} onClose={closeUserSelectDialog} type='customer' excludedIds={excludedIds} />
        </>
    );

    return [dialog, openUserSelectDialog] as const;
};

export default useUserSelectDialogForCertifier;
